export default __webpack_public_path__ + "static/media/AppSlide.04bc44df.svg";